import React from 'react';
import { LuArrowLeft } from 'react-icons/lu';

const HomeButton = ({label = 'Go Back To Home' }) => {
  const handleNavigate = () => {
    window.location.href = 'https://studybuddy.ing';
  };

  return (
    <button
      onClick={handleNavigate}
      className="flex items-center justify-center gap-2 px-4 py-2 w-full bg-black text-white rounded hover:bg-blue-700 transition"
    >
      <LuArrowLeft className="h-4 w-4" />
      <span>{label}</span>
    </button>
  );
};

export default HomeButton;